// apps/roleforge-app/src/components/audit/ActivationPositioningParagraph.tsx
//
// Plan 3e-ii Task 5.6 — Methodology positioning paragraph for the
// Activation Moment screen. Renders the verbatim copy from
// `@vibecontrol/shared/roleforge`.

import { ACTIVATION_POSITIONING_COPY } from '@vibecontrol/shared/roleforge';

export function ActivationPositioningParagraph() {
  return (
    <section className="rounded-xl border border-slate-200 dark:border-slate-700 bg-gradient-to-br from-slate-50 dark:from-slate-900/40 to-white p-6 mb-6">
      <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-3">
        {ACTIVATION_POSITIONING_COPY.headline}
      </h2>
      <p className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed whitespace-pre-line">
        {ACTIVATION_POSITIONING_COPY.body}
      </p>
    </section>
  );
}
